// extracted by mini-css-extract-plugin
export default {"Header":"RegulatedMaterial_Header__Rm1ZW","InfoText":"RegulatedMaterial_InfoText__nZ8q4"};